import React from 'react'
import './PriceCard.css'
import { TbCheck } from 'react-icons/tb'
import { useLanguage } from '../../../../LanguageProvider';

export default function PriceCard({ title, price, specs, onClick, isCurrent }) {
    const { getTranslation } = useLanguage();

    return (
        <div onClick={onClick} className={`price-card-container ${isCurrent ? "active" : ""}`}>
            <span className='price-card-title'>{title}</span>
            <span className='price-card-price'>{price}<span className='price-card-month'>/month</span></span>
            <span className='price-card-specs-holder'>
                {specs?.map(spec => (
                    <span className='price-card-spec'><TbCheck color='var(--add-modal-font-color)' size={16} strokeWidth={4} style={{ marginRight: '14.5px', width: '16px', minWidth: '16px', marginTop: '4px' }} /> {spec}</span>
                ))}
            </span>

            {isCurrent &&
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 'auto' }}>
                    <span className='price-card-current-plan'>{getTranslation("currentPlan")}</span>
                </div>
            }

        </div>
    )
}
